module.exports = __webpack_public_path__ + "media/application/images/logo-3b7fc252c99dae74363de45dcdad5487.svg";